// extracted by mini-css-extract-plugin
export default {"title":"title_title__tBezT","title__active":"title_title__active__Q8AMk","title__ended":"title_title__ended__zkBGA","date":"title_date__KYhBf"};